<script lang="ts">
	export let title: string;
	export let isActive: boolean = false;
	export let dark: boolean = false;
	export let id: string;
	export let as: 'link' | 'button' = 'button';
	export let linkTo: string = '';
</script>

{#if as === 'button'}
	<button class={`${$$props.class || ''} button`} class:dark class:active={isActive} on:click {id}>
		<slot />
		{title}
	</button>
{:else}
	<a
		href={linkTo}
		class={`${$$props.class} button`}
		class:dark
		class:active={isActive}
		on:click
		{id}
	>
		<slot />
		{title}
	</a>
{/if}

<style lang="scss">
	@import 'filterButton';
</style>
